(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monaco-community"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('monaco-community'))customElements.define('monaco-community',class extends HTMLElement{
    connectedCallback(){
      if(this.hasAttribute('data-enhanced'))return;
      this.track=this.querySelector('.mch__track');this.cards=[...this.querySelectorAll('.mch__card')];this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.position=this.querySelector('[data-position]');this.setAttribute('data-enhanced','');
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.prev.addEventListener('click',()=>this.move(-1),options);this.next.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});
      this.track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);}},options);
      this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
    }
    update(){const step=this.cards[1]?this.cards[1].offsetLeft-this.cards[0].offsetLeft:1;this.index=Math.min(this.cards.length-1,Math.max(0,Math.round(this.track.scrollLeft/step)));this.position.textContent=(this.index+1)+' / '+this.cards.length;this.prev.disabled=this.index===0;this.next.disabled=this.index===this.cards.length-1;}
    move(delta){const index=Math.max(0,Math.min(this.cards.length-1,this.index+delta));this.track.scrollTo({left:this.cards[index].offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.removeAttribute('data-enhanced');}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monaco-vehicle-selector"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('monaco-vehicle-selector')){
    customElements.define('monaco-vehicle-selector',class extends HTMLElement{
      connectedCallback(){
        if(this.hasAttribute('data-enhanced'))return;
        this.buttons=[...this.querySelectorAll('[data-brand]')];
        this.panels=[...this.querySelectorAll('[data-panel]')];
        this.panels.forEach(panel=>panel.hidden=true);
        this.setAttribute('data-enhanced','');
        this.buttons.forEach(button=>button.addEventListener('click',()=>this.select(button)));
        this.querySelectorAll('.mvs__reset').forEach(button=>button.addEventListener('click',()=>this.reset()));
        this.addEventListener('keydown',event=>{if(event.key==='Escape'){this.reset();}});
      }
      select(button){
        const selected=button.getAttribute('aria-expanded')!=='true';
        this.buttons.forEach(item=>item.setAttribute('aria-expanded',String(selected&&item===button)));
        this.panels.forEach(panel=>panel.hidden=!(selected&&panel.dataset.panel===button.dataset.brand));
        this.active=selected?button:null;
      }
      reset(){const previous=this.active;this.buttons.forEach(button=>button.setAttribute('aria-expanded','false'));this.panels.forEach(panel=>panel.hidden=true);this.active=null;previous?.focus();}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
